export default __webpack_public_path__ + "static/webRotator/svg/f893deb9e6343d92455be130b9db2e13.svg";